import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { BillingAndDeliveryForm } from './BillingAndDeliveryForm/Layout.js';
import { AddressBookModal } from './AddressBookModal/Layout.js';

var AddressesSection = (_param)=>{
    var { addressForm , addressSummary , editRef , handleModalClose , handleModalOpen , handleSelectAddress , initialSelectedAddress , isAddressBookEmpty , isAddressBookLoading , isAddressBookLoadingFailed , isAddressBookUnavailable , isModalOpen , labels , onAddAddress , showBillingAddressSummary , shippingDetails  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "addressForm",
        "addressSummary",
        "editRef",
        "handleModalClose",
        "handleModalOpen",
        "handleSelectAddress",
        "initialSelectedAddress",
        "isAddressBookEmpty",
        "isAddressBookLoading",
        "isAddressBookLoadingFailed",
        "isAddressBookUnavailable",
        "isModalOpen",
        "labels",
        "onAddAddress",
        "showBillingAddressSummary",
        "shippingDetails"
    ]);
    if (isAddressBookUnavailable) {
        return /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, swcHelpers.extends({}, rest, {
            editRef: editRef,
            handleModalOpen: handleModalOpen,
            shippingDetails: shippingDetails
        }));
    }
    if (isAddressBookLoading) {
        return /*#__PURE__*/ React.createElement(Loader, null) // Fully covering loader of shipping step takes care of this one
        ;
    }
    if (isAddressBookLoadingFailed) {
        return /*#__PURE__*/ React.createElement("section", {
            className: "addresses-section",
            "data-t": "addresses-section"
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest",
            component: "h2",
            className: "checkout-step__title"
        }, labels.titles.addressSection), /*#__PURE__*/ React.createElement(Alert, {
            type: "info",
            icon: "info",
            title: labels.titles.prefillFailed,
            message: labels.message,
            className: "addresses-section__alert"
        }), /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, swcHelpers.extends({}, rest, {
            editRef: editRef,
            handleModalOpen: handleModalOpen,
            shippingDetails: shippingDetails
        })));
    }
    if (isAddressBookEmpty) {
        return /*#__PURE__*/ React.createElement("section", {
            className: "addresses-section",
            "data-t": "addresses-section"
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest",
            component: "h2",
            className: "checkout-step__title"
        }, labels.titles.addressSection), /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, swcHelpers.extends({}, rest, {
            editRef: editRef,
            handleModalOpen: handleModalOpen,
            shippingDetails: shippingDetails
        })));
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "addresses-section",
        "data-t": "addresses-section"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2",
        className: "checkout-step__title"
    }, labels.titles.addressSection), /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, swcHelpers.extends({}, rest, {
        addressSummary: addressSummary,
        editRef: editRef,
        handleModalOpen: handleModalOpen,
        shippingDetails: shippingDetails,
        showBillingAddressSummary: showBillingAddressSummary
    })), /*#__PURE__*/ React.createElement(AddressBookModal, {
        addressForm: addressForm,
        addressSummary: addressSummary,
        initialSelectedAddress: initialSelectedAddress,
        isOpen: isModalOpen,
        onAddAddress: onAddAddress,
        onModalClose: handleModalClose,
        onSelectAddress: handleSelectAddress
    }));
};

export { AddressesSection };
//# sourceMappingURL=AddressesSection.js.map
